// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import tracker from 'share/tracking/Izenda.Tracker';
import { observable, action } from 'mobx';
import UiState from 'logic/Izenda.UiState';
import { omit } from 'lodash/fp';

@tracker
export default class EmailConfiguration {
  @observable id = null;
  @observable tenantId = null;
  @observable server = '';
  @observable port = null;
  @observable secureConnection = false;
  @observable login = '';
  @observable password = '';
  @observable displayName = '';
  @observable emailFromAddress = '';
  @observable useSystemConfiguration = true;
  @observable version = null;
  @observable created = null;
  @observable createdBy = null;
  @observable modified = null;
  @observable modifiedBy = null;

  constructor(data: any) {
    data && this.populateData(data);
  }

  /**
   * Set value by key
   * @param {string} key 
   * @param {any} value 
   */
  @action
  setValueByKey(key: string, value: any) {
    this[key] = value;
    this.markDirty();
  }

  /**
   * Populate Data
   */
  @action
  populateData(data: any) {
    this.useSystemConfiguration = data.useSystemConfiguration;
    this.tenantId = data.tenantId || UiState.tenantId;
    // Ignore other data when it belong to a tenant which use system configuration
    if (this.tenantId && this.useSystemConfiguration) return;
    this.id = data.id;
    this.server = data.server;
    this.port = data.port;
    this.secureConnection = data.secureConnection;
    this.login = data.login;
    this.password = data.password;
    this.displayName = data.displayName;
    this.emailFromAddress = data.emailFromAddress;
    this.useSystemConfiguration = data.useSystemConfiguration;
    this.version = data.version;
    this.created = data.createdBy;
    this.modified = data.modified;
    this.modifiedBy = data.modifiedBy;
  }

  /**
   * Clone a EmailConfiguration
   * @returns {EmailConfiguration}
   */
  clone() {
    return new EmailConfiguration(this);
  }

  /**
   * Build data for save, remove useSystemConfiguration property if system in system's mode
   */
  buildDataForSave() {
    return !this.tenantId ? omit(['useSystemConfiguration'], this) : this;
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.EmailConfiguration.js